<script>
import NavBar from '@components/nav-bar.vue'

export default {
  components: { NavBar },
}
</script>

<template>
  <div class="container-fluid">
    <NavBar />
    <div class="row mt-3">
      <div class="col-10 offset-1 alert alert-info">
      This is a prototype built to test user experience. Design has not been addressed. Many features are 'mocked'.
        Feedback: <a href="http://twitter.com/robrhyne">@robrhyne</a>
      </div>
    </div>
    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}
</style>
